export class Publisher {
    id: string;
    name: string;
    email: string;
    commercialName: string;
    phone: string;
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/models/publisher.ts